<template>
  <v-btn v-draggable-button="{ enabled: ! isKanbanMode, start, move, end }" v-bind="$attrs">
    <slot></slot>
  </v-btn>
</template>

<script>
  import { mapActions } from 'pinia';
  import useDependenciesStore from '@/stores/dependencies';
  import useUiPlanningStore from '@/stores/ui/planning';
  import usePlanningElementsStore from '@/stores/planning/elements';

  export default {
    props: {
      planning: { type: Object, required: true },
      el: { type: Object, required: true },
      isKanbanMode: { type: Boolean, default: false },
    },
    data() {
      return {
        dependenciesStore: useDependenciesStore(),
        uiPlanningStore: useUiPlanningStore(),
      };
    },
    methods: {
      start() {
        this.uiPlanningStore.doNotDisplayElementMenu = true;
      },
      move(event) {
        const $pointerEl = document.elementFromPoint(event.clientX, event.clientY); // x, y in viewport
        const $targetEl = ! $pointerEl?.closest('.element-menu') && $pointerEl?.closest('.element'); // avoid element menu
        const targetElId = parseInt($targetEl?.id?.replace('el', ''), 10);
        const targetEl = targetElId && targetElId != this.el.id && this.planning.elements.find(el => el.id == targetElId);
        if (! targetEl || ! targetEl.isType('task', 'milestone') || ! targetEl.hasDates()) {
          this.dependenciesStore.draggingLink = { el: this.el, pageX: event.pageX, pageY: event.pageY };
          event.target.dragData.dragClone.style.background = 'rgb(var(--v-theme-surface))';
          event.target.dragData.dragClone.style.color = null;
          event.target.dragData.dragClone.style.opacity = 0.8;
          return;
        }

        event.target.dragData.dragClone.style.background = 'rgb(var(--v-theme-successgreen))';
        event.target.dragData.dragClone.style.color = 'white';
        event.target.dragData.dragClone.style.opacity = 1;

        const isSuccessor = ! (targetEl.getStartTime().isBefore(this.el.getStartTime()) && targetEl.getEndTime().isBefore(this.el.getEndTime()));
        if (isSuccessor) {
          this.dependenciesStore.draggingLink = { el: this.el, targetEl, pageX: event.pageX, pageY: event.pageY };
        } else {
          this.dependenciesStore.draggingLink = { el: targetEl, targetEl: this.el, pageX: event.pageX, pageY: event.pageY };
        }
      },
      end(event) {
        this.dependenciesStore.draggingLink = null;
        this.uiPlanningStore.doNotDisplayElementMenu = false;
        const $pointerEl = document.elementFromPoint(event.clientX, event.clientY); // x, y in viewport
        const $targetEl = ! $pointerEl?.closest('.element-menu') && $pointerEl?.closest('.element'); // avoid element menu
        const targetElId = parseInt($targetEl?.id?.replace('el', ''), 10);
        if (! targetElId || targetElId == this.el.id) return;
        const targetEl = this.planning.elements.find(el => el.id == targetElId);
        if (! targetEl || ! targetEl.isType('task', 'milestone') || ! targetEl.hasDates()) return;

        this.startChangingElement();
        const isSuccessor = ! (targetEl.getStartTime().isBefore(this.el.getStartTime()) && targetEl.getEndTime().isBefore(this.el.getEndTime()));
        this.dependenciesStore.addDependency(this.el, targetEl, isSuccessor);
        this.changingElement();
      },
      ...mapActions(usePlanningElementsStore, ['startChangingElement', 'changingElement']),
    },
  };
</script>
